import React, { Component } from 'react';
import GetLoading from './getLoading';
import GetLogin from './getLogin';
import GetAppActive from './getAppActive';
import GetUbicacionStep from './getUbicacionStep';
import 'whatwg-fetch';
class getHome extends Component {
  constructor(props){
    super(props);
    this.state = {
        modulo : '',
        token_Client: '',
        accion: '',
        lon: this.props.lon,
        lat: this.props.lat,
        uuid_imagen:'',
        uuid_sucursal:'',
        telefono_contacto:''
    }
  }
  setCerrarSesion =()=>{
    localStorage.removeItem('TokenClient'+this.props.database);
    window.location.reload(false)
  }
  setTokenClient =(token_Client)=>{
    localStorage.setItem('TokenClient'+this.props.database,token_Client);
    window.location.reload(false)
  }
  setModule =(modulo)=>{
    this.state({
      modulo
    })
  }

  getUserTmp =()=>{
    const url= this.props.dir_url + "webapp/getIdUserTemp"
    const token =  this.props.token
    var obj = { accion:'usertemp', token };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
        if(data[0].status==="ok"){
         localStorage.lat = 0
         localStorage.lon    = 0
         localStorage.setItem('is_cookies'+this.props.database, "OK")
         localStorage.setItem('TokenClient'+this.props.database, data[0].msg);
         this.setState({
           modulo : "app-active",
           token_Client:  data[0].msg,
           accion: ''
         })
       }
    })
    .catch(console.log)
  }



  buscarTheme =()=>{
    const url= this.props.dir_url + "webapp/getTheme";
    const token =  this.props.token

    var obj = { accion:'theme', token };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
        //console.log(data)
      if(data[0].status==="ok"){
        //this.props.props_set_data_items(data)
        document.documentElement.style.setProperty("--color-primario", data[0].__color_primario);
        document.documentElement.style.setProperty("--color-secundario", data[0].__color_secundario);
        document.documentElement.style.setProperty("--color_terciario", data[0].__color_terciario);
        document.documentElement.style.setProperty("--logo_general", data[0].__logo_general);
        document.documentElement.style.setProperty("--color_fondo_letra", data[0].__color_fondo_letra);
        document.documentElement.style.setProperty("-color_lineas", data[0].__color_lineas);
        document.documentElement.style.setProperty("--color_letras", data[0].__color_letras);
        this.setState(
          {
            uuid_imagen:data[0].uuid_imagen,
            uuid_sucursal:data[0].uuid_sucursal,
            telefono_contacto:data[0].telefono_contacto
          }
        )

      }

    })
    .catch(console.log)
  }

  get_ubicacion=()=>{
    const lat = localStorage.lat_tmp
    const lon = localStorage.lon_tmp
    if(lat&&lon){
      if(Number(lat)>0||Number(lat)<0){
        localStorage.lat = lat
        localStorage.lon = lon
        this.setState({
          lat,lon
        })
      }
    }
  }
  render() {
    //console.log(this.state.lat+"sucursal")
    const modulo = this.state.modulo
    let dir_modulo
    if(modulo===''){
      dir_modulo = <GetLoading token={this.props.token} dir_url={this.props.dir_url}/>
    }else{
      if(modulo==='login'){
        dir_modulo = <GetLogin database={this.props.database} telefono_contacto={this.state.telefono_contacto} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}  uuid_imagen={this.state.uuid_imagen} codigo={this.props.codigo} setModule={this.setModule} token={this.props.token} dir_url={this.props.dir_url} setTokenClient={this.setTokenClient}/>
      }else{
        if((Number(this.state.lat)>0||Number(this.state.lat)<0)||(this.props.sucursal)){
          if(modulo==='app-active'){
            dir_modulo = <GetAppActive id_mesa={this.props.id_mesa} sucursal={this.props.sucursal} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60} uuid_sucursal={this.state.uuid_sucursal}  setCerrarSesion={this.setCerrarSesion}  setModule={this.setModule} token={this.props.token} dir_url={this.props.dir_url} token_Client={this.state.token_Client}/>
          }
        }else{
          dir_modulo = <GetUbicacionStep get_ubicacion={this.get_ubicacion} lat={localStorage.lat} lon={localStorage.lon} codigo={this.props.codigo}
          setModule={this.setModule} token={this.props.token} dir_url={this.props.dir_url} setTokenClient={this.setTokenClient}/>
        }
      }
    }
    /*if(this.props.accion!=='next_cliente'){
      if(localStorage.codigo){

      }else{
        dir_modulo = <GetUbicacionStep lat={this.props.lat} lon={this.props.lon} codigo={this.props.codigo} setModule={this.setModule} token={this.props.token} dir_url={this.props.dir_url} setTokenClient={this.setTokenClient}/>
      }
    }*/

    //codigo={codigo} lat={lat} lon={lon} accion={accion}

    return (
      <div className="cssversion_content_global" tabIndex="-1">
        <div className="cssversion_subcontent">
          {dir_modulo}
        </div>
      </div>
    )
  }
  login_step_one = ()=>{
    //localStorage.codigo = this.props.codigo
    localStorage.lat = this.props.lat
    localStorage.lon    = this.props.lon
    localStorage.setItem('is_cookies'+this.props.database, "OK")
    this.setState({
      modulo : "login",
      token_Client: '',
      accion: ''
    })
  }
  componentDidMount (){
    const id_mesa = this.props.id_mesa
    if(Number(id_mesa)!==0){
      this.getUserTmp();
    }else{
      const is_cookies = localStorage.getItem('is_cookies'+this.props.database)
      const tokenClient = localStorage.getItem('TokenClient'+this.props.database)
      if(this.props.accion==='next_cliente'){
        if(!is_cookies||is_cookies!=='OK'){
          this.login_step_one()
        }else{
          if(is_cookies==="OK"){
              localStorage.lat = this.props.lat
              localStorage.lon    = this.props.lon
              let modulo = "login"
              if(tokenClient){
                modulo = "app-active"
              }
              this.setState({
                modulo,
                token_Client:tokenClient
              })
          }
        }
      }
    }
    this.buscarTheme()
  }


}
export default getHome;
